import { useGetExamPaperByIdQuery as useGetExaminationResultById } from '../../generated/graphql';

export default useGetExaminationResultById;
